// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconOutlookColor = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <g clipPath="url(#icon-outlook-color_svg__clip0_173_22849)" fill="#0072C6">
      <path d="M14.986 5.088v4.695l1.64 1.033a.42.42 0 00.181 0l7.06-4.76c0-.564-.525-.968-.821-.968h-8.06z" />
      <path d="M14.986 11.534l1.497 1.029c.211.155.466 0 .466 0-.254.155 6.92-4.61 6.92-4.61v8.628c0 .94-.602 1.334-1.278 1.334h-7.606v-6.38h.001zM7.234 9.37c-.51 0-.916.24-1.217.719-.3.478-.45 1.112-.45 1.9 0 .801.15 1.434.45 1.899.3.466.694.698 1.181.698.502 0 .9-.227 1.195-.68.293-.452.441-1.08.441-1.883 0-.837-.142-1.49-.428-1.955-.286-.465-.676-.698-1.172-.698z" />
      <path d="M.131 2.704V21.07L14.103 24V0L.13 2.704zm9.35 12.288c-.59.777-1.36 1.167-2.31 1.167-.927 0-1.68-.377-2.263-1.13-.583-.753-.875-1.734-.875-2.944 0-1.277.296-2.31.888-3.099.592-.789 1.377-1.183 2.353-1.183.922 0 1.668.376 2.237 1.132.57.755.855 1.75.855 2.986 0 1.27-.295 2.294-.885 3.071z" />
    </g>,
    <defs>
      <clipPath id="icon-outlook-color_svg__clip0_173_22849">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  );
export default SvgIconOutlookColor;
